import React from 'react';
import GuestHeader from '../../layout/GuestHeader'
import Footer from '../../layout/Footer';
import {Helmet} from "react-helmet";

const TermsAndConditions = () => {

  return (
    <>
      <Helmet>
          <title>Terms and Conditions | Oreca Pro</title>
          <link rel="canonical" href={window.location.href} />
      </Helmet>
      <GuestHeader />
      <section className='guest-section relative min-h-[100vh] pb-20'>
        <div className='w-full max-w-[1000px] relative mx-auto text-left px-4 pt-[120px] md:pt-[160px]'>
          <h1 className='text-3xl font-semibold my-5 text-center'>Terms and Conditions</h1>
          <p className='text-sm text-gray-400 mb-7 text-center'>Last Updated: November 2025</p>
          
          <div className='space-y-6 text-gray-300'>
            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>1. Acceptance of Terms</h2>
              <p>
                By accessing and using Oreca Pro ("the App"), you accept and agree to be bound by these Terms and Conditions. 
                If you do not agree to these terms, please do not use the App.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>2. Description of Service</h2>
              <p>
                Oreca Pro is a personalized ocean forecast application that allows users to:
              </p>
              <ul className='list-disc list-inside ml-4 mt-2 space-y-1'>
                <li>Save custom ocean spots using an interactive map</li>
                <li>Set ideal conditions for each saved spot</li>
                <li>View daily and hourly weather forecasts for saved locations</li>
                <li>Receive ratings based on how current conditions match your preferences</li>
              </ul>
              <p className='mt-3'>
                The App can be used for any ocean or weather-dependent activity including surfing, kitesurfing, windsurfing, sailing, fishing, kayaking, and more.
              </p>
              <p className='mt-3'>
                Forecast ratings are personalized and calculated based on the ideal conditions you set for each spot.
              </p>
              <p className='mt-3 font-semibold text-white'>
                Privacy Note: All spots you save are private and visible only to you. They are not shared with or visible to other Oreca Pro users.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>3. Development Phase</h2>
              <p>
                Oreca Pro is currently in its first release and development phase. Features, functionality, and availability 
                may change without notice. We are continuously working to improve the App and plan to introduce new features.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>4. User Accounts</h2>
              <p>To use Oreca Pro, you must:</p>
              <ul className='list-disc list-inside ml-4 mt-2 space-y-1'>
                <li>Create an account by providing accurate information (name, email address)</li>
                <li>Verify your email address</li>
                <li>Maintain the security of your account credentials</li>
                <li>Be at least 13 years of age</li>
              </ul>
              <p className='mt-3'>
                You are responsible for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>5. Weather Data and Accuracy</h2>
              <p>
                Forecast data is provided by Open Meteo Weather API, a third-party service. We display this data using Mapbox GL for mapping functionality.
              </p>
              <p className='mt-2'>
                <strong>Important:</strong> Weather forecasts are predictions and may not always be accurate. Do not rely solely on this App for 
                safety-critical decisions. Always check multiple sources and use your own judgment when planning ocean activities.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>6. Limitation of Liability</h2>
              <p>
                Oreca Pro and its operators are not responsible for:
              </p>
              <ul className='list-disc list-inside ml-4 mt-2 space-y-1'>
                <li>Inaccurate weather data or forecasts</li>
                <li>Service interruptions or unavailability</li>
                <li>Any injuries, damages, or losses resulting from use of the App</li>
                <li>Third-party data accuracy (Open Meteo, Mapbox)</li>
              </ul>
              <p className='mt-3'>
                The App is provided "as is" without warranties of any kind, either express or implied.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>7. User Conduct</h2>
              <p>You agree not to:</p>
              <ul className='list-disc list-inside ml-4 mt-2 space-y-1'>
                <li>Use the App for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to the App or its systems</li>
                <li>Interfere with or disrupt the App's functionality</li>
                <li>Share your account credentials with others</li>
                <li>Use automated systems to access the App without permission</li>
              </ul>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>8. Intellectual Property</h2>
              <p>
                All content, features, and functionality of Oreca Pro are owned by the App operators and are protected by copyright 
                and intellectual property laws. You may not copy, modify, or distribute any part of the App without express permission.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>9. Account Termination</h2>
              <p>
                We reserve the right to suspend or terminate your account at any time for violation of these terms or for any other reason. 
                You may delete your account at any time through the App settings.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>10. Changes to Terms</h2>
              <p>
                We may update these Terms and Conditions at any time. Continued use of the App after changes constitutes acceptance 
                of the revised terms. We will notify users of significant changes via email or in-app notification.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>11. Governing Law</h2>
              <p>
                These Terms and Conditions are governed by the laws of South Africa. Any disputes will be resolved in accordance 
                with South African law and jurisdiction.
              </p>
            </section>

            <section>
              <h2 className='text-xl font-semibold text-white mb-3'>12. Contact Information</h2>
              <p>
                For questions about these Terms and Conditions, please contact us at: info@oreca.pro
              </p>
            </section>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
